// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
import constants from '../lib/constants'
import _ from 'lodash'
import { loadJob, CREATE_PLACEHOLDER_JOB, loadImagesForJob } from './jobs'

export const LOAD_DEVICES = 'LOAD_DEVICES'
export const UPDATE_DEVICE = 'UPDATE_DEVICE'
export const SET_JOB = 'SET_JOB'

// ------------------------------------
// Actions
// ------------------------------------

/*  This is a thunk, meaning it is a function that immediately
    returns a function for lazy evaluation. It is incredibly useful for
    creating async actions, especially when combined with redux-thunk! */

const intervalIds = {}

export const loadDeviceHistory = (deploymentState) => {
  return (dispatch, getState) => {
    return axios.get(`${constants.API_URL}/devices/internal/all_activity_history`, {
      params: {
        'deployment_state': deploymentState || constants.DEPLOYMENT_STATES.PRODUCTION
      }
    })
    .then((response) => {
      dispatch({
        type: LOAD_DEVICES,
        payload: response.data
      })
    })
  }
}

export const startJob = (deviceString, stripType, note = null) => {
  return (dispatch) => {
    return axios.post(
      `${constants.API_URL}/devices/${deviceString}/start`,
      {
        strip_type: stripType,
        note
      }
    ).then((response) => {
      const jobId = response.data.job_id
      dispatch({
        type: SET_JOB,
        payload: {
          device_string: deviceString,
          runningJobId: jobId
        }
      })
      dispatch({
        type: CREATE_PLACEHOLDER_JOB,
        payload: jobId
      })
      const pollingFunction = () => {
        dispatch(loadJob(jobId))
        .then((data) => {
          if (data && data.job_status === constants.JOB_STATUSES.COMPLETED) {
            dispatch(loadImagesForJob(jobId))
            clearInterval(intervalIds[jobId])
            delete intervalIds[jobId]
          }
        })
      }
      pollingFunction()
      intervalIds[jobId] = setInterval(pollingFunction, 5000)
      return response
    })
  }
}

const startTest = (deviceString, testSetName) => {
  return axios.post(
    `${constants.API_URL}/devices/${deviceString}/request_unit_tests`,
    {
      test_set_name: testSetName
    }
  )
}

export const runCommunicationsTest = (deviceString) => {
  return (dispatch) => {
    return startTest(deviceString, 'communications')
  }
}

export const runStageTest = (deviceString) => {
  return (dispatch) => {
    return startTest(deviceString, 'stage_move')
  }
}

export const runLinacMoveTest = (deviceString) => {
  return (dispatch) => {
    return startTest(deviceString, 'linac_move')
  }
}

export const runMotorTest = (deviceString) => {
  return (dispatch) => {
    return startTest(deviceString, 'motor_move')
  }
}

export const runLedTest = (deviceString) => {
  return (dispatch) => {
    return startTest(deviceString, 'led')
  }
}

export const promoteDevice = (device, nextDeploymentState = null) => {
  if (!nextDeploymentState) {
    if (device.data.deployment_state === constants.DEPLOYMENT_STATES.RESEARCH) {
      nextDeploymentState = constants.DEPLOYMENT_STATES.MANUFACTURING
    } else if (device.dad.deployment_state === constants.MANUFACTURING) {
      nextDeploymentState = constants.DEPLOYMENT_STATES.STAGING
    } else {
      nextDeploymentState = constants.DEPLOYMENT_STATES.PRODUCTION
    }
  }
  return (dispatch) => {
    return axios.post(
      `${constants.API_URL}/devices/${device.device_string}/set_deployment_state`,
      {
        'deployment_state': nextDeploymentState
      }
    ).then(() => {
      dispatch({
        type: UPDATE_DEVICE,
        payload: {
          'device_string': device.device_string,
          data: {
            deployment_state: nextDeploymentState
          }
        }
      })
    })
  }
}

export const refreshDeviceData = (deviceString) => {
  return (dispatch, getState) => {
    return axios.get(
      `${constants.API_URL}/devices/internal/${deviceString}/`
    )
    .then((response) => {
      dispatch({
        type: UPDATE_DEVICE,
        payload: response.data
      })
    })
  }
}

export const pushTestData = (deviceString, results) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_DEVICE,
      payload: {
        'device_string': deviceString,
        data: {
          'unit_test_results': results
        }
      }
    })
    return axios.post(
      `${constants.API_URL}/devices/${deviceString}/put_unit_test_results`,
      {
        results,
        'product_type': 'device'
      }
    )
    .then((response) => {
      dispatch({
        type: UPDATE_DEVICE,
        payload: response.data
      })
    })
  }
}

export const pushPCBTestData = (deviceString, results) => {
  return (dispatch, getState) => {
    return axios.post(
      `${constants.API_URL}/devices/${deviceString}/put_unit_test_results`,
      {
        results,
        'product_type': 'pcb'
      }
    )
    .then((response) => {
      dispatch({
        type: UPDATE_DEVICE,
        payload: response.data
      })
    })
  }
}

export const actions = {
  loadDeviceHistory,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOAD_DEVICES]    : (state, action) => ({
    ...action.payload,
    ...state
  }),
  [UPDATE_DEVICE]   : (state, action) => {
    const { device_string } = action.payload
    let newDevice = _.clone(state[device_string])
    newDevice = _.merge(newDevice, action.payload)
    return {
      ...state,
      [device_string]: newDevice
    }
  },
  [SET_JOB]         : (state, action) => {
    const { device_string } = action.payload
    return _.merge({}, state, {
      [device_string]: action.payload
    })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
export default function devicesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/deviceHistory.js